export const loadKakaoMap = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (document.getElementById('kakao-map-script')) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.id = 'kakao-map-script';
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${import.meta.env.VITE_KAKAO_MAP_API_KEY}&libraries=services,clusterer&autoload=false`;
        script.onload = () => {
            (window as any).kakao.maps.load(resolve);
        };
        script.onerror = reject;

        document.head.appendChild(script);
    });
};